<template>
    <div>
        <PageTitle :pages="pages" :title=titles.functionalityListExpression v-if="showPageTitle"/>
        <Table
                :okPressed="okPressed"
                @deleted="handleDeleted"
                @getDomaine="handleEditModule"
        />
        <modal-delete :message="'Voulez-vous confirmer la suppression?'" @okPressed="handleOk" id="delete-functionality"
                      name="functionnality"/>
        <modal-success :title=titles.deleteFunctionalitySuccesTitle @messageFromModal="closeModal"
                       id="success-delete-functionality"/>
        <modal-error :title="titles.deleteFunctionalityErrorTitle" id="error-delete-functionality"/>
    </div>
</template>

<script>
    import PageTitle from '@/components/common/PageTitle';
    import ModalDelete from '@/components/common/modal-confirm';
    import Table from './Table';
    import ModalSuccess from '../../common/modal-success';
    import {titles} from '../../../utils/general/titles.js';
    import {name} from '../../../utils/general/routers.js';
    import ModalError from '../../common/modal-error';

    export default {
        name: 'Index',
        props: {
            showPageTitle: {
                type: Boolean,
                default: true
            },
            showAddButton: {
                type: Boolean,
                default: true
            },
            getUserEmail: {
                type: String
            }
        },
        components: {
            ModalError,
            Table,
            PageTitle,
            ModalDelete,
            ModalSuccess
        },
        data() {
            return {
                titles,
                okPressed: null,
                functionnalityToEdit: null,
                pages: []
            };
        },
        methods: {
            handleEditModule(e) {
                this.functionnalityToEdit = e;
            },
            handleOk(e) {
                this.okPressed = e;
            },
            handleDeleted(e) {
                this.okPressed = e;
            },
            closeModal() {
                this.$router.go();
            }
        },
        created() {
            this.pages.push(
                {
                    name: titles.settings,
                    router: name.settings,
                    active: false
                },
                {
                    name: titles.functionnalityList,
                    router: name.functionnalityList,
                    active: false
                },
                {
                    name: titles.functionalityListExpression,
                    router: null,
                    active: true
                }
            );
        }
    };
</script>

<style scoped></style>
